import { SiteState, ServerWebsocketData } from '../SiteState/SiteStateTypes';
import LayoutManagerWrapper from '../Layouts/LayoutManager';
import { useEffect, useState } from 'react';
import { mockWebsocketRunner } from './MockWebsocketRunner';
import { staticStateLoader } from './StaticStateLoader';

function SiteStateManager() {
    const [siteState, setSiteState] = useState<SiteState>();

    useEffect(() => {
        const staticState = staticStateLoader();

        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const websocketURL = `${protocol}//${window.location.host}/ws`;

        const mockWebsocket = Number(process.env.REACT_APP_WEBSOCKET_MOCK) === 1;

        if (!websocketURL) {
            return;
        }

        if (mockWebsocket) {
            mockWebsocketRunner(staticState, setSiteState);
            return;
        }

        const socket = new WebSocket(websocketURL);

        socket.onopen = () => {
            console.log("WebSocket connected");
        };

        socket.onmessage = (event) => {
            console.log("Received:", event.data);

            const data: ServerWebsocketData = JSON.parse(event.data);

            if (data.phoneNumber === staticState.phoneNumber) {
                setSiteState({ staticState: staticState, dynamicState: data.dynamicSiteState });
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            console.log("WebSocket disconnected");
        };

        return () => {
            socket.close();
        };
    }, []);

    if (!siteState) {
        return;
    }

    return (
        <LayoutManagerWrapper siteState={siteState} />
    );
}

export default SiteStateManager


